import React from 'react';

const Nav = () => {
    return (
        <header className='bg-[#ffffff] custom-shadow h-14 lg:h-20 fixed top-0 left-0 w-full z-10 flex items-center justify-center'>
            <div className='flex items-center justify-center h-full'>
                <img 
                    src="https://lib.hku.hk/sites/all/themes/bootstrap/hkul_subtheme/images/hkul-logo@2x.png" 
                    alt="HKU Logo" 
                    className='h-8 mx-auto sm:h-10 lg:h-12'
                />
            </div>
        </header>
    );
};

export default Nav;
